import { useEffect, useState } from 'react';

export function useTabControl(
  defaultValue: string,
  set: Function
): [boolean, Function, Function] {
  const [showClose, setShowClose] = useState(false);

  const [_defaultValue, _] = useState(defaultValue);

  const showCloseBtn = () => {
    setShowClose(() => true);
  };

  const hideCloseBtn = () => {
    setShowClose(() => false);
    // reset the tab to default state
    set(() => _defaultValue);
  };

  useEffect(() => {
    // reset on page load
    if (showClose) {
      hideCloseBtn();
    }
  }, []);

  return [showClose, showCloseBtn, hideCloseBtn];
}
